export enum NotificationActions {
  MarkAsRead = 'markAsUnread',
  MarkAsUnread = 'markAsRead',
}
